export default {
  deleteCustomizationSetting(_, key) {
    return new Promise((resolve, reject) => {
      // Must user $.ajax until the controller is setup to authenticate api users
      $.ajax(`/customizations/${key}.json`, {
        type: "DELETE",
        success: () => resolve(),
        error: (e) => {
          window.notify.error(e.responseJSON.value.join(","));
          reject();
        }
      });
    });
  },
  updateCustomizationSetting(_, data) {
    return new Promise((resolve, reject) => {
      // Must user $.ajax until the controller is setup to authenticate api users
      $.ajax(`/customizations/${data.customization.key}.json`, {
        type: "PUT",
        dataType: "JSON",
        data,
        success: () => resolve(),
        error: (e) => {
          window.notify.error(e.responseJSON.value.join(","));
          reject();
        }
      });
    });
  }
};
